class FatalQueueError extends Error {
  constructor(message, sentryTags = {}) {
    super(message);
    this.sentryTags = sentryTags;
  }
}

export default FatalQueueError;
